import {memo, PropsWithChildren, ReactNode} from "react";

import * as SC from "./index.styles";

export interface TooltipProps {
  content?: ReactNode;
  primary?: boolean;
  align?: AlignSetting;
  position?: "right" | "left";
}

export const Tooltip = memo(function TooltipComponent(
  props: PropsWithChildren<TooltipProps> & Pick<JSX.IntrinsicElements["div"], "style" | "className">,
) {
  const {content, primary, children, align, position, ...rest} = props;

  return (
    <SC.Wrapper {...{rest, position}}>
      {children}
      <SC.Tooltip {...{align, primary}}>
        {content}
      </SC.Tooltip>
    </SC.Wrapper>
  );
});
